import React, { Component } from 'react';

class Percents extends Component {
  interval = null
  state = {
    value: 0,
    isFake: false,
  }

  componentDidMount() {
    this.interval = setInterval(this.handleInterval, 1000)
  }

  handleInterval = () => {
    let value = this.props.onGetValue()
    let fake = false

    if (value <= this.state.value) {
      value = Math.min(1, this.state.value + 0.001)
      fake = true
    }

    if (!value || value > this.state.value) {
      this.setState({ value, fake })
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  render() {
    return (
      <span>{(this.state.value * 100).toFixed(1)}%{this.state.fake && ' Please wait...'}{this.state.value === 1 && ' (finalizing...)'}</span>
    )
  }
}

export default Percents;



// WEBPACK FOOTER //
// ./src/components/Percents.js